import { queryOptions, useQuery } from '@tanstack/react-query';
import { hydraUiApi } from '@/services/api';

const STALE_TIME = 0;

export const googleDriveCredentialKeys = {
  accessToken: (accountId: number, userId: number) =>
    ['account', accountId, 'user', userId, 'google-drive-credential', 'access-token'] as const,
};

export type GetGoogleDriveAccessTokenInput = {
  accountId: number;
  userId: number;
};

export async function getGoogleDriveAccessToken({
  accountId,
  userId,
}: GetGoogleDriveAccessTokenInput): Promise<string> {
  const response = await hydraUiApi.users.getGoogleDriveCredentialAccessToken({
    params: { path: { account_id: String(accountId), id: String(userId) } },
  });

  return response.access_token;
}

export function getGoogleDriveAccessTokenQueryOptions({ accountId, userId }: GetGoogleDriveAccessTokenInput) {
  return queryOptions({
    queryKey: googleDriveCredentialKeys.accessToken(accountId, userId),
    queryFn: () => getGoogleDriveAccessToken({ accountId, userId }),
    staleTime: STALE_TIME,
  });
}

export function useGoogleDriveAccessToken(input: GetGoogleDriveAccessTokenInput) {
  return useQuery(getGoogleDriveAccessTokenQueryOptions(input));
}
